import React from 'react'
import { Package } from 'lucide-react'

interface EmptyStateProps {
  icon?: React.ElementType
  title: string
  description: string
  action?: { label: string; onClick: () => void; size?: 'sm' | 'default' | 'lg' }
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon = Package, title, description, action }) => (
  <div className="flex flex-col items-center justify-center p-12 text-center rounded-lg">
    <div className="flex items-center justify-center h-16 w-16 rounded-xl bg-muted/50 mb-5">
      <Icon className="h-8 w-8 text-muted-foreground" />
    </div>
    <h3 className="text-xl font-semibold text-foreground mb-2">{title}</h3>
    <p className="text-muted-foreground mb-6">{description}</p>
    {action && (
      <button
        onClick={action.onClick}
        type="button"
        className={`inline-flex items-center justify-center font-medium transition-colors rounded-lg bg-accent text-accent-foreground hover:bg-accent/90 ${
          action.size === 'sm' ? 'px-3 py-1.5 text-sm' : action.size === 'lg' ? 'px-5 py-2.5 text-base' : 'px-4 py-2 text-sm'
        }`}
      >
        {action.label}
      </button>
    )}
  </div>
)
